module.exports = __webpack_public_path__ + "static/media/5_3.fa1c3136.png";